<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>Premium Levels</h1>
      <p *ngIf="!isSignupMode">Sign in to your account</p>
      <p *ngIf="isSignupMode">Create a new account</p>
    </div>

    <!-- Login Form -->
    <form *ngIf="!isSignupMode" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="submitted && f['email'].errors"
          [readonly]="otpSent"
          placeholder="Enter your email"
          (keydown.enter)="onEmailEnter($event)"
        />
        <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
          <div *ngIf="f['email'].errors['required']">Email is required</div>
          <div *ngIf="f['email'].errors['email']">Email must be a valid email address</div>
        </div>
      </div>

      <div *ngIf="!otpSent" class="form-group">
        <button 
          type="button" 
          class="btn-send-otp" 
          [disabled]="!isEmailValid || sendingOtp"
          (click)="sendOtp()">
          <span *ngIf="!sendingOtp">Send Password</span>
          <span *ngIf="sendingOtp">Sending...</span>
        </button>
      </div>

      <div *ngIf="otpSent" class="form-group">
        <label for="otp">One Time Password</label>
        <input
          type="text"
          id="otp"
          formControlName="otp"
          class="form-control"
          [class.is-invalid]="submitted && f['otp'].errors"
          placeholder="Enter the OTP sent to your email"
        />
        <div *ngIf="submitted && f['otp'].errors" class="invalid-feedback">
          <div *ngIf="f['otp'].errors['required']">OTP is required</div>
        </div>
        <button type="button" class="btn-link" (click)="resetOtp()">Use a different email</button>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <button *ngIf="otpSent" type="submit" class="btn-login" [disabled]="loading">
        <span *ngIf="!loading">Login</span>
        <span *ngIf="loading">Logging in...</span>
      </button>
    </form>

    <!-- Signup Form -->
    <form *ngIf="isSignupMode" [formGroup]="signupForm" (ngSubmit)="onSignupSubmit()" class="login-form">
      <div class="form-group">
        <label for="firstName">First Name <span class="required">*</span></label>
        <input
          type="text"
          id="firstName"
          formControlName="firstName"
          class="form-control"
          [class.is-invalid]="signupSubmitted && sf['firstName'].errors"
          placeholder="Enter your first name"
        />
        <div *ngIf="signupSubmitted && sf['firstName'].errors" class="invalid-feedback">
          <div *ngIf="sf['firstName'].errors['required']">First name is required</div>
          <div *ngIf="sf['firstName'].errors['maxlength']">First name cannot exceed 50 characters</div>
        </div>
      </div>

      <div class="form-group">
        <label for="lastName">Last Name <span class="required">*</span></label>
        <input
          type="text"
          id="lastName"
          formControlName="lastName"
          class="form-control"
          [class.is-invalid]="signupSubmitted && sf['lastName'].errors"
          placeholder="Enter your last name"
        />
        <div *ngIf="signupSubmitted && sf['lastName'].errors" class="invalid-feedback">
          <div *ngIf="sf['lastName'].errors['required']">Last name is required</div>
          <div *ngIf="sf['lastName'].errors['maxlength']">Last name cannot exceed 50 characters</div>
        </div>
      </div>

      <div class="form-group">
        <label for="signupEmail">Email <span class="required">*</span></label>
        <input
          type="email"
          id="signupEmail"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="signupSubmitted && sf['email'].errors"
          placeholder="Enter your email"
        />
        <div *ngIf="signupSubmitted && sf['email'].errors" class="invalid-feedback">
          <div *ngIf="sf['email'].errors['required']">Email is required</div>
          <div *ngIf="sf['email'].errors['email']">Email must be a valid email address</div>
        </div>
      </div>

      <div class="form-group">
        <label for="phone">Phone Number <span class="optional">(optional)</span></label>
        <input
          type="tel"
          id="phone"
          formControlName="phone"
          class="form-control"
          [class.is-invalid]="signupSubmitted && sf['phone'].errors"
          placeholder="Enter your phone number"
        />
        <div *ngIf="signupSubmitted && sf['phone'].errors" class="invalid-feedback">
          <div *ngIf="sf['phone'].errors['pattern']">Please enter a valid phone number</div>
        </div>
      </div>

      <div *ngIf="signupErrorMessage" class="error-message">
        {{ signupErrorMessage }}
      </div>

      <div *ngIf="signupSuccessMessage" class="success-message">
        {{ signupSuccessMessage }}
      </div>

      <button type="submit" class="btn-login" [disabled]="submittingSignup">
        <span *ngIf="!submittingSignup">Sign Up</span>
        <span *ngIf="submittingSignup">Creating account...</span>
      </button>
    </form>

    <!-- Toggle between Login and Signup -->
    <div class="toggle-mode">
      <span *ngIf="!isSignupMode">First time user? <button type="button" class="btn-link-inline" (click)="toggleSignupMode()">Sign up here</button></span>
      <span *ngIf="isSignupMode">Already have an account? <button type="button" class="btn-link-inline" (click)="toggleSignupMode()">Login here</button></span>
    </div>
  </div>
</div>
